import { useEffect, useState } from "react";

// Turma/disciplina atualmente selecionada no menu lateral (localStorage).
// Reativo: reage ao evento "disciplinaAtual:changed" e ao "storage" para que o
// bloqueio por permissão recalcule ao trocar de turma SEM precisar atualizar a
// página.
export function useDisciplinaAtual() {
  const [id, setId] = useState(
    () => localStorage.getItem("disciplinaAtualId") || null,
  );

  useEffect(() => {
    const sync = () => setId(localStorage.getItem("disciplinaAtualId") || null);
    window.addEventListener("disciplinaAtual:changed", sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener("disciplinaAtual:changed", sync);
      window.removeEventListener("storage", sync);
    };
  }, []);

  return id;
}
